'use client'

import { useLivePreview } from '@payloadcms/live-preview-react'

import { PageContent } from './PageContent'
import { getClientSideURL } from '@/utilities/getURL'

type PageData = {
  title: string
  description?: string | null
  icon?: string | null
  blocks?: any[]
  showLastUpdated?: boolean | null
  updatedAt: string
}

type Props = {
  initialPage: PageData
}

export const PagePreview = ({ initialPage }: Props) => {
  const { data } = useLivePreview<PageData>({
    depth: 2,
    initialData: initialPage,
    serverURL: getClientSideURL(),
  })

  if (!data) return null

  return <PageContent page={data} />
}
